import React, { useContext } from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import { ViewerContext } from 'common/containers/ViewerContainer';
import AdminOnboardingFieldLabel from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from 'common/subdomain/admin/AdminOnboarding/AdminOnboardingMultiSelect';
import { whatOptions } from 'common/subdomain/admin/AdminOnboarding/data';
import VStack from 'common/uiV3/VStack';
import getFirstName from 'common/util/getFirstName';

import type { RegistrationStepProps } from 'common/subdomain/admin/AdminOnboarding/Types';

const AdminOnboardingWhat = ({ onChange, onboarding }: RegistrationStepProps) => {
  const viewer = useContext(ViewerContext);

  const onChangeSelect = (motivations: string[]) => {
    onChange({
      motivations,
    });
  };

  const { motivations } = onboarding;
  const name = getFirstName(viewer?.name) || 'there';

  return (
    <RegistrationWrapper.Content className="gap-6">
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>Hey {name}, what brings you to Canny?</RegistrationWrapper.Title>
      </RegistrationWrapper.Header>
      <VStack className="gap-2">
        <AdminOnboardingFieldLabel isRequired>Select all that apply</AdminOnboardingFieldLabel>
        <AdminOnboardingMultiSelect
          optionType="card"
          onChange={onChangeSelect}
          options={whatOptions}
          selected={motivations}
        />
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingWhat;
